
<div class="flex justify-center">
  <div>
    <label for="theme">Media type:</label>
    <nb-select filled status="primary" placeholder="Select type"
      [(ngModel)]="type" [ngModelOptions]="{standalone: true}">
      <nb-option [value]="'single'">Single image</nb-option>
      <nb-option [value]="'language_specific'">Language specific</nb-option>
    </nb-select>
  </div>
</div>

<div *ngIf="type == 'single'">
  <app-media-selector type="image" [gameId]="gameId" [templateId]="templateId" [fileURL]="_model.data?.fileURL" (mediaUpdated)="imageUpdated(null, $event)"></app-media-selector>
</div>

<div class="grid grid-cols-{{languages?.length}}" *ngIf="type == 'language_specific'">
  <div *ngFor="let lang of languages">
      <app-media-selector type="image" [gameId]="gameId" [templateId]="templateId" [fileURL]="_model.data[lang]?.fileURL" (mediaUpdated)="imageUpdated(lang, $event)"></app-media-selector>
  </div>
</div>

<!--media json:{{_model | json}}-->
  